import React, { Component } from 'react'
import './loader.css'

class Loader extends Component {
  render () {
    return (
        <div className="loader">
          <img src="/images/5.gif" alt=""/>
        </div>
    )
  }
}

export default Loader


// WEBPACK FOOTER //
// ./src/components/loader/Loader.js